import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-company-overview',
  templateUrl: './company-overview.component.html',
  styleUrls: ['./company-overview.component.scss'],
})
export class CompanyOverviewComponent implements OnInit {
  @Input() cin: any;
  @Input() all_data;

  public heighlights: any = {};

  isPremium = false;
  plan: any;
  isAdvance = false;
  isFree = false;
  companyOverview: any;
  companyNews: any;
  fragment: any;
  productList: any;
  onSession: any;

  constructor(
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private router: Router,
    private toastService: ToastService,
    private tansactionService: TansactionService,
    private commonService: CommonService,
    private loginSignupService: LoginSignupService
  ) {}

  ngOnInit(): void {
    this.onSession = this.localStorageService.getItem('onSession')
    this.route.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });
    this.companyOverview = this.all_data;
    this.productList = this.all_data.product_list;
    this.commonService.putProductData(this.all_data.product_list['FCD']);

    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }

    if(this.companyOverview.cin == 'L72200DL2000PLC108985' || this.companyOverview.cin == 'L93030DL2010PLC198141'){
      this.isPremium = true;
      this.isAdvance = false;
      this.isFree = false;
      this.plan = 'plan_premium';
    }
  }

  peopleTab() {
    const company_name = this.all_data.name.toLowerCase().replaceAll(' ', '-')
    this.router.navigate(['/company/', company_name, 'people']);
  }

  clicked = false;

  addToCart(sku) {
    if (
      this.onSession == undefined ||
      this.onSession == '' ||
      this.onSession == null
    ) {
      this.localStorageService.setItem("redirect_url",this.router.url);
      this.router.navigate(['/user/login']);
    } else {
      this.clicked = true;
      let currentOption;
      currentOption = {
        sku: sku,
      };
      this.tansactionService.addProductToCart(currentOption).then(
        (data: any) => {
          if (this.plan === 'plan_premium' || this.plan === 'plan_advance') {
            this.toastService.addSingle(
              'success',
              'Email Sent',
              'Please check your email.'
            );
          } else {
            this.toastService.addSingle(
              'success',
              'Item added to cart',
              'Make payment to complete this transaction.'
            );
          }
        },
        (err) => {
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      );
    }
  }
}
